/** Heuristic composition from outline role + content density. */
export function assignCompositionToSection(section, slideIndex) {
    const role = section.role;
    if (role === "cover" || role === "section" || role === "cta") {
        return "full-bleed";
    }
    if (role === "quote") {
        return "center-panel";
    }
    if (role === "data") {
        return section.visual?.kind === "chart" ? "center-panel" : "full-bleed";
    }
    if (role === "comparison") {
        return "split";
    }
    const hasBullets = section.bullets.length > 0;
    if (hasBullets) {
        return slideIndex % 2 === 0 ? "text-left" : "text-right";
    }
    if (section.subtitle?.trim()) {
        return slideIndex % 2 === 0 ? "text-top" : "text-bottom";
    }
    return "text-left";
}
